import { createContainer } from 'unstated-next'
import { useCallback, useState } from 'react'

function useActionBar({ step = 1, initialAction = null } = {}) {
  const [currentStep, setCurrentStep] = useState(step)
  const [action, setActionInternal] = useState(initialAction)
  const [buttonText, setButtonText] = useState(`Proceed to audit`)
  const [isDisabled, intSetIsDisabled] = useState(false)
  const previousStep = useCallback(() => setCurrentStep(currentStep - 1), [currentStep, setCurrentStep])
  const nextStep = useCallback(() => setCurrentStep(currentStep + 1), [currentStep, setCurrentStep])
  const changeStep = useCallback((newStep) => setCurrentStep(newStep), [setCurrentStep])
  const setAction = useCallback((newAction) => (typeof newAction === 'function' ? setActionInternal(() => newAction) : setActionInternal(null)), [setActionInternal])
  const setIsDisabled = useCallback((newValue) => intSetIsDisabled(!!newValue), [intSetIsDisabled])

  return {
    action,
    setAction,
    buttonText,
    setButtonText,
    currentStep,
    previousStep,
    nextStep,
    changeStep,
    isDisabled,
    setIsDisabled
  }
}

export const ActionBarState = createContainer(useActionBar)

export default ActionBarState
